export enum CalibrationModel {
  EFFECTIVE_ENERGY_GT2_SIMPLE = 'effectiveEnergyGT2Simple',
  EFFECTIVE_ENERGY_GT2_MULTI_CAGE = 'effectiveEnergyGT2MultiCage',
}
